"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_tutorials(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "cedc3a56-ce6c-4584-9765-f9f1d5bbbe23",
    "data-name": "Info_circle_ic_mid",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "17a2e9bf-533b-4b10-9e4d-44dccf20bfbb",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "30c322f6-0e2b-4246-81f9-536d9fd97c84",
    "data-name": "<Pfad>",
    cx: 94,
    cy: 61,
    r: 2,
    fill: "none",
    stroke: "#e60000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "96 134 96 82 88 82",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 134,
    x2: 104,
    y2: 134,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 78,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("title", null, "tutorials-mid"), /*#__PURE__*/React.createElement("g", {
    id: "4e30b777-be2a-4ffe-9574-e940814b737d",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("use", {
    id: "0c5fcf8d-84d5-4e13-9264-1a8501ee5ab5",
    "data-name": "Info_circle_ic_mid",
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#cedc3a56-ce6c-4584-9765-f9f1d5bbbe23"
  })));
}

var _default = ic_tutorials;
exports.default = _default;